export default __webpack_public_path__ + "static/media/congressOfYoungScientists.fb25f1d6.pdf";